import mapValues from 'lodash/mapValues'
import { ENDPOINTS } from 'utils/api/callApi'
import { IRateAPI } from 'apps/marketplace/store/contractLanes/types'
import { RADIUS_RATE } from 'apps/marketplace/utils/constants/rates'
import { preparePickupTimePreferences } from 'apps/marketplace/utils/helpers/rates'

export const prepareSaveLanesRequestData = (
  lane: IRateAPI,
  creationSource: string,
  specificLaneId?: string
) => {
  const {
    actionType,
    carrierCapacity,
    carrierId: carrierApplicationId,
    contractId,
    deliveryLocation,
    deliveryRadiusMiles,
    deliveryTimePreference,
    dispatcher,
    equipmentId,
    expirationDate,
    isDatMarketApplicable,
    isOnlyBeer,
    isOnlyDropTrailer,
    isShipperExclusive,
    laneId: datMarketLaneId,
    loadType,
    pickupLocation,
    pickupRadiusMiles,
    pickupTimeEveryday,
    pickupTimePreferences,
    pickupTimeType,
    radiusRates,
    rate,
    rateType,
    shipperId: shipperApplicationId,
    startDate,
    user,
  } = lane

  const adding = !contractId

  const { city: pCity, countryCode: pCountry, state: pState } = pickupLocation
  const { city: dCity, countryCode: dCountry, state: dState } = deliveryLocation || {}
  const sendUser = dispatcher ? { dispatcherId: dispatcher } : { user }
  const { pickupCity, pickupRadius, pickupStateCode, values: limitValues } = carrierCapacity || {}

  const carrierApplicationOfferLimits = carrierCapacity?.alreadySet
    ? undefined
    : {
        carrierApplicationId,
        ...mapValues(limitValues, value => value || 0),
        pickupCity,
        pickupStateCode,
        pickupRadius,
      }

  const commonProps = {
    creationSource,
    carrierApplicationId,
    datMarketLaneId,
    equipmentId,
    loadType,
    actionType,
    expirationDate,
    carrierApplicationOfferLimits,
    startDate,
    isOnlyBeer,
    isOnlyDropTrailer,
    isDatMarketApplicable,
    pickupAttributes: { city: pCity, stateCode: pState, countryCode: pCountry },
    pickupRadiusMiles,
    ...sendUser,
    shipperApplicationId,
    isShipperExclusive,
    deliveryTimePreference,
    pickupTimePreferences: preparePickupTimePreferences(
      pickupTimeType,
      pickupTimePreferences,
      carrierCapacity,
      pickupTimeEveryday
    ),
    shipperCityLaneId: specificLaneId,
  }

  const isRadiusRate = rateType === RADIUS_RATE

  return {
    endpoint: ENDPOINTS.contractLanes,
    method: isRadiusRate || adding ? 'POST' : 'PUT',
    id: !(isRadiusRate || adding) ? contractId : undefined,
    group: isRadiusRate ? 'batch_process_lanes' : undefined,
    body: isRadiusRate
      ? {
          contractLanes: radiusRates
            .filter(({ checked, id }) => checked || id)
            .map(({ checked, id, max, min, value }) => ({
              _destroy: id && !checked,

              carrierContractLaneId: id,
              rate: value,
              deliveryRadiusRangeMin: min,
              deliveryRadiusRangeMax: max,
              ...commonProps,
            })),
        }
      : {
          contractLane: {
            rate,
            deliveryAttributes: { city: dCity, stateCode: dState, countryCode: dCountry },
            deliveryRadiusMiles,
            ...commonProps,
          },
        },
  }
}
